import React from 'react';
import { CheckIcon, GlobeIcon, ShieldCheckIcon } from 'lucide-react';
import { bonuses, tomes, valueRows } from '../data/site';
import { CtaButton } from './CtaButton';
import { CountdownTimer } from './CountdownTimer';
import { ScarcityBar } from './ScarcityBar';
const includes = ['One-time payment', 'Instant digital access', 'Lifetime access according to the offer terms', '6 complete clinical tomes', '5 premium bonuses'];
export function OfferSection() {
  return <section id="offer" className="w-full bg-navy px-5 py-14 sm:px-6 sm:py-20" data-id="element-203" data-mp="mejtm8wd2dqx">
      <div className="mx-auto max-w-3xl" data-id="element-204" data-mp="mgo6vhg5gp3v">
        <h2 className="text-center font-serif text-[28px] font-bold leading-[1.12] text-cream sm:text-4xl" data-id="element-205" data-mp="rdn07xrzos10">
          Here’s everything you get today
        </h2>

        <div className="mt-8 grid gap-4 sm:grid-cols-2" data-id="element-206" data-mp="2t59j1c1q9gme">
          <div className="rounded-2xl bg-white/[0.06] p-5 ring-1 ring-inset ring-white/10" data-id="element-207" data-mp="2t6udl1o1kzk9">
            <p className="text-[11px] font-bold uppercase tracking-[0.12em] text-gold-light" data-id="element-208" data-mp="2y55ozgtzji4l">The 6-tome desk</p>
            <ul className="mt-3 space-y-2" data-id="element-209" data-mp="12p39pghe24tz">
              {tomes.map(tome => <li key={tome.numeral} className="flex items-start gap-2" data-id="element-210" data-mp="xw0aostue36e">
                  <CheckIcon className="mt-0.5 h-3.5 w-3.5 shrink-0 text-gold-light" aria-hidden="true" data-id="element-211" data-mp="swxg62bhnfco" />
                  <span className="text-[14px] leading-snug text-cream/85" data-id="element-212" data-mp="owwsdr2i1rsy">
                    {tome.numeral} — {tome.title}
                  </span>
                </li>)}
            </ul>
          </div>
          <div className="rounded-2xl bg-white/[0.06] p-5 ring-1 ring-inset ring-white/10" data-id="element-213" data-mp="1gokznz6f7o4x">
            <p className="text-[11px] font-bold uppercase tracking-[0.12em] text-gold-light" data-id="element-214" data-mp="1ckd8zwgejy42">Plus 5 bonuses</p>
            <ul className="mt-3 space-y-2" data-id="element-215" data-mp="17m3c9hf14pgc">
              {bonuses.map(bonus => <li key={bonus.label} className="flex items-start gap-2" data-id="element-216" data-mp="17asf1eaz8jw">
                  <CheckIcon className="mt-0.5 h-3.5 w-3.5 shrink-0 text-gold-light" aria-hidden="true" data-id="element-217" data-mp="3scav5d8mztri" />
                  <span className="text-[14px] leading-snug text-cream/85" data-id="element-218" data-mp="3ttpzsepixvfc">
                    {bonus.label} — {bonus.title}
                  </span>
                </li>)}
            </ul>
          </div>
        </div>

        {/* Value stack + price */}
        <div className="mt-6 rounded-3xl border border-gold/40 bg-cream p-5 sm:p-8" data-id="element-219" data-mp="3ouwmone5g6fp">
          <p className="text-center text-[11px] font-bold uppercase tracking-[0.14em] text-navy/55" data-id="element-220" data-mp="3owzijo1zgtsc">
            The value of your complete desk
          </p>
          <ul className="mt-4 divide-y divide-navy/10" data-id="element-221" data-mp="3fv9rwkfxdyvm">
            {valueRows.map(row => <li key={row.name} className="flex items-baseline justify-between gap-4 py-2.5" data-id="element-222" data-mp="316dd84jd5nm1">
                <span className="text-[14px] leading-snug text-navy/75" data-id="element-223" data-mp="365ginq399vuj">{row.name}</span>
                <span className="shrink-0 text-[14px] font-bold text-navy/60 line-through" data-id="element-224" data-mp="2s4dwzeg6ank5">{row.value}</span>
              </li>)}
          </ul>

          <div className="mt-4 flex items-baseline justify-between gap-4 rounded-xl bg-sand px-4 py-3" data-id="element-225" data-mp="2x5jq3ddqwcu7">
            <span className="text-[12px] font-bold uppercase tracking-[0.1em] text-navy" data-id="element-226" data-mp="2djrw2l153bu3">
              Total reference value
            </span>
            <span className="font-serif text-2xl font-bold text-navy line-through" data-id="element-227" data-mp="2mjoew60ulgh8">$344</span>
          </div>

          <div className="mt-7 text-center" data-id="element-228" data-mp="2ig8mxmzq44av">
            <p className="text-[14.5px] leading-relaxed text-navy/70" data-id="element-229" data-mp="2wgt4kftwju2s">
              But you won’t pay $344. You won’t pay $197. You won’t even pay $97.
            </p>
            <p className="mt-5 text-[11px] font-bold uppercase tracking-[0.16em] text-gold" data-id="element-230" data-mp="2rhg6eyxkz0kw">Today only</p>
            <p className="mt-1 font-serif text-[64px] font-bold leading-none text-navy sm:text-7xl" data-id="element-231" data-mp="365t8mdn9hfnu">$27</p>
            <p className="mt-1 text-[13px] font-bold uppercase tracking-[0.12em] text-navy/60" data-id="element-232" data-mp="319m7cy5t8sc8">
              USD · One-time payment
            </p>

            <div className="mt-6" data-id="element-233" data-mp="3a8zal93cckoi">
              <CtaButton label="Yes, I want the complete desk" note="Instant digital access · No monthly subscription" data-id="element-234" data-mp="3aa0ve5a5sljf" />
            </div>

            <div className="mt-6" data-id="element-235" data-mp="1dgk4fvep5olt">
              <CountdownTimer tone="light" data-id="element-236" data-mp="1dfs8ukl3nqvj" />
            </div>

            <div className="mt-7" data-id="element-237" data-mp="1i9d9kke2uyyf">
              <ScarcityBar tone="light" data-id="element-238" data-mp="1ib7mbbf73krf" />
            </div>

            <div className="mt-6 flex items-start gap-2.5 rounded-xl border border-navy/10 bg-white px-4 py-3 text-left" data-id="element-239" data-mp="1m95caggsiavv">
              <GlobeIcon className="mt-0.5 h-4 w-4 shrink-0 text-gold" aria-hidden="true" data-id="element-240" data-mp="pm90o4bv60hd" />
              <p className="text-[13px] leading-snug text-navy/70" data-id="element-241" data-mp="ujiwq2trdae6">
                <strong className="font-bold text-navy" data-id="element-242" data-mp="yjszz7q61mpc">Automatic currency conversion.</strong> The price is
                shown in USD and converted automatically to your local currency at checkout — pay in the
                currency of your country.
              </p>
            </div>

            <ul className="mt-6 grid gap-2 text-left sm:grid-cols-2" data-id="element-243" data-mp="2eyb4c2ltuwvl">
              {includes.map(item => <li key={item} className="flex items-start gap-2" data-id="element-244" data-mp="2p1pvhopdbsz7">
                  <ShieldCheckIcon className="mt-0.5 h-3.5 w-3.5 shrink-0 text-gold" aria-hidden="true" data-id="element-245" data-mp="2k3fz5arwqmc0" />
                  <span className="text-[13.5px] leading-snug text-navy/75" data-id="element-246" data-mp="2fcprtrzx89eo">{item}</span>
                </li>)}
            </ul>
          </div>
        </div>
      </div>
    </section>;
}